<div class="container">
    <div class="row mt-3 mb-3">
        <div class="col">
            <div class="card">
                <form [formGroup]="deviceFormGroup" (ngSubmit)="onDeviceFormsSubmit()">
                    <div class="card-header">
                        Devices
                    </div>
                    <div class="card-body">
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">name *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['name'] }" formControlName="name" />
                                <div *ngIf="validationErrorsArray['name']" class="invalid-feedback">
                                    {{validationErrorsArray['name']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">device manufacturers *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['deviceManufacturers'] }" formControlName="deviceManufacturers">
                                    <option *ngFor="let deviceManufacturer of deviceManufacturersVals"
                                        [value]="deviceManufacturer.id">
                                        {{deviceManufacturer.name}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['deviceManufacturers']" class="invalid-feedback">
                                    {{validationErrorsArray['deviceManufacturers']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">device type *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['deviceType'] }" formControlName="deviceType">
                                    <option *ngFor="let deviceType of deviceTypeVals" [value]="deviceType.id">
                                        {{deviceType.name}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['deviceType']" class="invalid-feedback">
                                    {{validationErrorsArray['deviceType']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">status *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" formControlName="status">
                                    <option *ngFor="let status of deviceStatus" [value]="status.value">
                                        {{status.label}}</option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="row">
                          <dt class="col-sm-3 text-right align-middle">
                              <label class="control-label col-form-label-sm">notes</label>
                          </dt>
                          <dd class="col-sm-3">
                              <textarea class="form-control form-control-sm" formControlName="notes" rows="10"></textarea>
                          </dd>
                        </dl>

                    </div>
                    <div class="card-footer">
                        <a class="btn btn-default btn-sm" href="/hardware/devices">
                            <i class="fa fa-times"></i> <br /> Cancel
                        </a>
                        <button class="btn btn-primary btn-sm float-right" type="submit">
                            <i class="fa fa-save"></i> <br />
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
